import classNames from "classnames";
import { useDarkMode } from "usehooks-ts";
import ToggleButton from "../button/ToggleButton";

type DarkModeButtonProps = {
  isMobile?: boolean;
}

const DarkModeButton = ({ isMobile }: DarkModeButtonProps) => {
  const { isDarkMode = false, toggle: toggleDarkMode } = useDarkMode(false);
  return (
    <div className={classNames({ "mode-type-toggle": true, "hidden-desktop": isMobile })}>
      <ToggleButton type={1} checked={isDarkMode} onToggle={isDarkMode ? toggleDarkMode : undefined } disabled={!isDarkMode} />
    </div>
  );
};

export default DarkModeButton;
